import { initializeHeader } from './_header';
import { initializeGlide } from './_carousel';
import { initializeYearDropdown } from './_formUtils';
import { initializeModalGallery } from './_modal';

// Wait for DOM content to be loaded before initializing everything
document.addEventListener("DOMContentLoaded", function() {
    initializeHeader();
    initializeGlide();
    initializeYearDropdown();
    initializeModalGallery();
});